export default {
	vipBenefits: {
		salaryTitle: 'VIP 급여',
		benefitsTitle: '혜택',
		yourVipProgress: 'VIP 진행 상황',
		progressToVip: 'VIP {level}까지 {percent}%',
		vipMax: '최고 레벨 달성',
		vipLevelBenefits: 'VIP 레벨 & 혜택',
		betXpRule: '베팅 {amount} = {xp}EXP',
		btnReceive: '수령',
		btnJoinIn: '참여하기',
		btnReceived: '수령 완료',
		btnExpired: '만료됨',
		btnNotSettled: '미정산',
		btnComingSoon: '곧 출시',
		btnViewMore: '더 보기',
		btnContactNow: '문의하기',
		guestTitleLevelup: '레벨업 보너스',
		guestTitleDaily: '데일리 급여',
		guestTitleWeekly: '위클리 급여',
		guestTitleMonthly: '먼슬리 급여',
		guestTitleCashback: '캐시백',
		guestTitleRescue: '레스큐 보너스',
		guestTitleEvents: 'VIP 이벤트',
		guestTitleSupport: 'VIP 지원',
		guestDescLevelup: '새로운 VIP 등급에 도달할 때마다 일회성 보너스를 받으세요.',
		guestDescDaily: 'VIP 등급이 올라갈수록 매일 급여 보상을 받으세요.',
		guestDescWeekly: 'VIP 등급이 올라갈수록 매주 급여 보상을 받으세요.',
		guestDescMonthly: 'VIP 등급이 올라갈수록 매월 급여 보상을 받으세요.',
		guestDescCashback: '게임 지출에 대해 캐시백을 받으세요.',
		guestDescRescue: '재기를 돕는 레스큐 보너스를 받으세요.',
		guestDescEvents: '높은 VIP 등급일수록 더 많은 독점 이벤트 보상이 잠금 해제됩니다.',
		guestDescSupport: '더 빠른 지원을 위한 전담 VIP 지원.',
		comingSoonHint: '혜택이 곧 제공됩니다. 기대해 주세요',
		receiveSuccess: '보상 수령 완료',
		receiveFailed: '보상 수령 실패',
		typeUpgrade: '레벨업 보너스',
		typeDailySalary: '일급',
		typeWeeklySalary: '주급',
		typeMonthlySalary: '월급',
		typeRebate: '캐시백',
		typeRescue: '레스큐 보너스',
		typeVipActivity: 'VIP 이벤트',
		typeVipService: 'VIP 지원',
		tooltipRecharge: '충전 {current}/{target}',
		tooltipBets: '베팅 {current}/{target}',
		progressRecharge: '충전',
		progressBets: '베팅',
		descUpgradeBonus: 'VIP{level} 승급 보너스 ×{count}',
		descDailySalary: 'VIP{level} 일급 ×{count}',
		descWeeklySalary: 'VIP{level} 주급 ×{count}',
		descMonthlySalary: 'VIP{level} 월급 ×{count}',
		descUpgradeBonusPlain: 'VIP{level} 승급 보너스',
		descDailySalaryPlain: 'VIP{level} 일급',
		descWeeklySalaryPlain: 'VIP{level} 주급',
		descMonthlySalaryPlain: 'VIP{level} 월급',
		descRebate: 'VIP{level} 게임 캐시백',
		descRescue: 'VIP{level} 레스큐 보너스',
		descVipActivity: '높은 VIP 등급일수록 더 많은 독점 이벤트 보상이 잠금 해제됩니다.',
		descVipService: '더 빠른 지원을 위한 전담 VIP 지원.',
		allBenefits: '모든 혜택',
		vipClubTitle: 'VIP Club',
		more: '더 보기',
		moreDesc: '자세한 내용은 프로모션을 확인하세요.',
		promotions: '프로모션',
		highlightsTitle: '8가지 핵심 혜택',
		highlightSupport: 'VIP 전용 지원',
		highlightLevelup: '레벨업 보너스',
		highlightSalary: 'VIP 급여',
		highlightRescue: 'VIP 구조 보너스',
		highlightGifts: 'VIP 전용\n선물',
		highlightEvents: 'VIP 이벤트',
		highlightService: 'VIP 전담\n서비스',
		highlightWallet: 'VIP\n크레딧 지갑',
		currentLevel: '현재 레벨',
		keepPlayingReach: '계속 플레이하여 도달하세요',
		higherLevelRewards: '레벨이 높을수록 더 큰 보상',
		levelUpUnlock: '레벨을 올려 전용 혜택을 잠금 해제하고 프리미엄 경험을 즐기세요.',
		yourVipBenefits: '나의 VIP 혜택',
		viewVipLevels: 'VIP 레벨 보기',
		exclusiveBenefitsTitle: '나의 전용 혜택',
		tipExclusiveRewards: '전용 보상',
		tipHigherRakeback: '더 높은 리베이트',
		tipPrioritySupport: '우선 지원',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: '레벨',
		tableRequiredXp: '필요 EXP',
		tableLevelUpBonus: '레벨업 보너스',
		tableDailyRakeback: '일일 리베이트',
		tableWeeklyLossback: '주간 손실 환급',
		signIn: '로그인',
		vipClubDefaultDesc: '지금 VIP Club에 가입하고 선물, 경품, 다양한 특별 혜택을 받아보세요.',
	},
};
